// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Preloader_Wrapper__3ievh","Loader":"Preloader_Loader__2z1KY"};